import { z } from "zod";

import { FilterFieldConfig } from "@/modules/common/filters";
import {
  TARIFF_CATEGORY_OPTIONS,
  TARIFF_MODALITY_OPTIONS,
  TARIFF_PERIOD_OPTIONS,
  TARIFF_TENSION_SUBGROUP_OPTIONS,
  TARIFF_TYPE_OPTIONS,
  TariffCategories,
  TariffModalities,
  TariffPeriods,
  TariffTensionSubgroups,
  TariffTypes,
} from "@/modules/common/types/AneelTariffs.enum";
import useEnergyDistributorOptions from "@/modules/common/hooks/lists/useEnergyDistributorOptions";

export const ANEEL_TARIFF_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    key: "search",
    label: "Pesquisar",
    type: "text",
    placement: "inline",
    schema: z.string(),
  },
  {
    key: "energyDistributorId",
    label: "Distribuidora",
    type: "select-async",
    placement: "both",
    schema: z.string(),
    useOptions: useEnergyDistributorOptions,
  },
  {
    key: "modality",
    label: "Modalidade",
    type: "select",
    placement: "both",
    schema: z.coerce.number().pipe(z.enum(TariffModalities)),
    options: TARIFF_MODALITY_OPTIONS,
  },
  {
    key: "type",
    label: "Tipo",
    type: "select",
    placement: "both",
    schema: z.coerce.number().pipe(z.enum(TariffTypes)),
    options: TARIFF_TYPE_OPTIONS,
  },
  {
    key: "tensionSubgroup",
    label: "Subgrupo",
    type: "select",
    placement: "modal",
    schema: z.coerce.number().pipe(z.enum(TariffTensionSubgroups)),
    options: TARIFF_TENSION_SUBGROUP_OPTIONS,
  },
  {
    key: "category",
    label: "Classe/Categoria",
    type: "select",
    placement: "modal",
    schema: z.coerce.number().pipe(z.enum(TariffCategories)),
    options: TARIFF_CATEGORY_OPTIONS,
  },
  {
    key: "period",
    label: "Período",
    type: "select",
    placement: "modal",
    schema: z.coerce.number().pipe(z.enum(TariffPeriods)),
    options: TARIFF_PERIOD_OPTIONS,
  },
  {
    key: "vigencia",
    label: "Vigência",
    type: "period",
    placement: "modal",
    schema: z.any(),
    inputs: [
      {
        key: "startDate",
        label: "Início da vigência",
        type: "date",
        schema: z.string(),
      },
      {
        key: "endDate",
        label: "Fim da vigência",
        type: "date",
        schema: z.string(),
      },
    ],
  },
];
